import pLimit from 'p-limit';
import { api, ApiError } from './api';
import type { Locale } from '../shared/content';
const limit = pLimit({ concurrency: 2, rejectOnClear: true });
export function cancelQueuedTranslations() {
  limit.clearQueue();
}
export function queuedTranslation(postId: string, locale: Locale, signal: AbortSignal) {
  return limit(async () => {
    for (let attempt = 0; attempt < 4; attempt++) {
      signal.throwIfAborted();
      try {
        return await api<{ status: string; body?: string }>('/translate', {
          method: 'POST',
          body: JSON.stringify({ postId, locale }),
          signal: AbortSignal.any([signal, AbortSignal.timeout(20000)]),
        });
      } catch (error) {
        if (!(error instanceof ApiError) || error.code !== 'TRANSLATION_BUSY' || attempt === 3) throw error;
        // Other readers share the provider budget. Retry temporary contention only.
        await new Promise<void>((done, fail) => {
          const abort = () => {
            clearTimeout(timer);
            fail(signal.reason);
          };
          const timer = setTimeout(
            () => {
              signal.removeEventListener('abort', abort);
              done();
            },
            750 * 2 ** attempt + Math.random() * 300,
          );
          signal.addEventListener('abort', abort, { once: true });
        });
      }
    }
    return { status: 'unavailable' };
  });
}
